// Version : 0.0.1
// Author : VIGNESH
// LastEdit : VIGNESH
// Last ADD : REMOVED UNWANTED REDUX
// MODFIED DATA : 06-12-2025

/* eslint-disable import/no-anonymous-default-export */
import staffReportActionTypes from './staff-report.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	fetchStaffDetailResponse: null,
	fetchStaffDetailArr: [],
	fetchStaffOfficerDetailResponse: null,
	fetchStaffOfficerDetailArr: [],
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/********************* FETCH STAFF REPORT DETAILS START *********************** */

		case staffReportActionTypes.GET_STAFF_DETAILS_SUCCESS:
			return {
				...state,
				fetchStaffDetailResponse: action.payload,
				fetchStaffDetailArr: docodeHexResponse(action.payload, 'StaffDetailsReportKey'),
			};

		case staffReportActionTypes.GET_STAFF_DETAILS_FAILURE:
			return { ...state, fetchStaffDetailResponse: action.payload };

		case staffReportActionTypes.GET_STAFF_DETAILS_RESPONSE_CHANGED:
			return { ...state, fetchStaffDetailResponse: null };
		/********************* FETCH STAFF REPORT DETAILS END *********************** */

		/********************* FETCH STAFF OFFICER DETAILS START *********************** */

		case staffReportActionTypes.GET_STAFF_OFFICER_SUCCESS:
			return {
				...state,
				fetchStaffOfficerDetailResponse: action.payload,
				fetchStaffOfficerDetailArr: docodeHexResponse(action.payload, 'StaffOfficerKey'),
			};

		case staffReportActionTypes.GET_STAFF_OFFICER_FAILURE:
			return { ...state, fetchStaffOfficerDetailResponse: action.payload };

		case staffReportActionTypes.GET_STAFF_OFFICER_RESPONSE_CHANGED:
			return { ...state, fetchStaffOfficerDetailResponse: null };
		/********************* FETCH STAFF OFFICER DETAILS END *********************** */

		default:
			return state;
	}
};
